import React, { useState, useEffect } from "react";
import { DateTime } from "fiver-react-ui-components";
import axios from "axios";
import Voucher from "./Voucher";
import VoucherActions from "./VoucherActions";
import VoucherContent from "./VoucherContent";
import VoucherImage from "./VoucherImage";
import VoucherText from "./VoucherText";
import VoucherSkeleton from "./VoucherSkeleton";
import WalletVoucherContainer from "./WalletVoucherContainer";
import { EmptyScreen } from "fiver-react-ui-components";
const skeletons = [1, 2, 3, 4];

const Wrapper = ({
  onError
}) => {
  const [transactions, setTransactions] = useState();
  const currencySymbol = process.env.REACT_APP_CURRENCY_SYMBOL || "£";
  const voucherAmount = process.env.REACT_APP_VOUCHER_PRIZE_AMOUNT || 5;
  useEffect(() => {
    (async function () {
      try {
        const transactionsRes = await axios.get(`/wallet/transactions?per_page=1000`); // setTimeout(() => {

        setTransactions(transactionsRes?.data?.data?.filter(item => item.type === "UBER_VOUCHER")); // }, 1000);
      } catch ({
        response
      }) {
        onError(response);
      }
    })();
  }, []);
  return transactions?.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, transactions.map(t => /*#__PURE__*/React.createElement(Voucher, null, /*#__PURE__*/React.createElement(VoucherImage, {
    voucherLink: t?.document?.uber_voucher_program?.code?.link
  }), /*#__PURE__*/React.createElement(VoucherContent, null, /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "10px"
    }
  }, /*#__PURE__*/React.createElement(VoucherText, {
    size: "xl"
  }, currencySymbol, voucherAmount, " off"), /*#__PURE__*/React.createElement(VoucherText, {
    size: "md",
    marginBottom: "8px"
  }, "your order")), /*#__PURE__*/React.createElement(VoucherText, {
    size: "sm",
    isLabel: true,
    marginBottom: "4px"
  }, "EXP", " ", /*#__PURE__*/React.createElement(DateTime, {
    format: "DD/MM/YY"
  }, t?.document?.uber_voucher_program?.ends_at))), /*#__PURE__*/React.createElement(VoucherActions, {
    voucherCode: t?.document?.uber_voucher_program?.code?.text
  })))) : transactions?.length === 0 ? /*#__PURE__*/React.createElement(EmptyScreen, {
    emptyIcon: "local_offer",
    emptyTitle: "No vouchers yet",
    emptySubtitle: "Enter a contest to win some!"
  }) : skeletons.map(s => /*#__PURE__*/React.createElement(VoucherSkeleton, {
    key: s
  }));
};

export default Wrapper;